import React, { useState } from "react";
import { Input, Button, DatePicker, Checkbox, Select, Tabs, Form } from "antd";
import { MailOutlined, FileImageOutlined, SmileOutlined } from "@ant-design/icons";

const { TextArea } = Input;
const { TabPane } = Tabs;

const PollComponent: React.FC = () => {
    const [options, setOptions] = useState(["Option 1", "Option 2"]);
    const [form] = Form.useForm();

    const addOption = () => {
        setOptions([...options, `Option ${options.length + 1}`]);
    };

    const removeOption = (index: number) => {
        setOptions(options.filter((_, i) => i !== index));
    };


    const onFinish = (values: any) => {
        console.log("Submitted Values: ", values);
    };

    return (
        <Form
            form={form}
            layout="vertical"
            onFinish={onFinish}
            style={{ marginTop: 20 }}
        >
            <Form.Item
                label="Title"
                name="title"
                rules={[{ required: true, message: "Please enter a question!" }]}
            >
                <Input placeholder="Type your question here" />
            </Form.Item>

            <Form.Item label="Answer Options" required>
                {options.map((option, index) => (
                    <div
                        key={index}
                        style={{ display: "flex", alignItems: "center", marginBottom: 8 }}
                    >
                        <Input
                            placeholder={`Option ${index + 1}`}
                            style={{ flex: 1 }}
                            defaultValue={option}
                            onChange={(e) =>
                                setOptions(
                                    options.map((opt, i) => (i === index ? e.target.value : opt))
                                )
                            }
                        />
                        <Button
                            type="text"
                            danger
                            onClick={() => removeOption(index)}
                            style={{ marginLeft: 8 }}
                        >
                            X
                        </Button>
                    </div>
                ))}
                <Button type="link" onClick={addOption} style={{ padding: 0 }}>
                    + Add Option
                </Button>
            </Form.Item>

            <Form.Item
                label="Poll Expires"
                name="pollExpires"
                rules={[{ required: true, message: "Please select a date!" }]}
            >
                <DatePicker />
            </Form.Item>

            <Form.Item name="notifyEmployees" valuePropName="checked">
                <Checkbox>Notify employees</Checkbox>
            </Form.Item>
        </Form>
    );
};

export default PollComponent;
